"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../utils");

var _excluded = ["name", "attribute", "facets", "updateFilter", "showMore", "selectAll"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Container = _styledComponents.default.div.withConfig({
  displayName: "RadioFilter__Container",
  componentId: "sc-7q2qyn-0"
})(["margin-bottom:1.3rem;"]);

var Title = _styledComponents.default.h4.withConfig({
  displayName: "RadioFilter__Title",
  componentId: "sc-7q2qyn-1"
})(["font-size:1.2rem;text-transform:uppercase;letter-spacing:0.3px;margin-bottom:0.5rem;color:#77899e;"]);

var FilterSearchForm = _styledComponents.default.form.withConfig({
  displayName: "RadioFilter__FilterSearchForm",
  componentId: "sc-7q2qyn-2"
})(["position:relative;"]);

var SelectAllElm = _styledComponents.default.button.withConfig({
  displayName: "RadioFilter__SelectAllElm",
  componentId: "sc-7q2qyn-3"
})(["cursor:pointer;color:#0a7be4;text-transform:uppercase;font-size:1.4rem;background:transparent;border:none;font-weight:400;outline:none;padding-right:0;padding-left:0;"]);

var ToggleElm = _styledComponents.default.div.withConfig({
  displayName: "RadioFilter__ToggleElm",
  componentId: "sc-7q2qyn-4"
})(["cursor:pointer;color:rgb(10,123,228);"]);

var Facet = _styledComponents.default.div.withConfig({
  displayName: "RadioFilter__Facet",
  componentId: "sc-7q2qyn-5"
})(["display:flex;margin-bottom:0.5rem;"]);

var FacetLabel = _styledComponents.default.label.withConfig({
  displayName: "RadioFilter__FacetLabel",
  componentId: "sc-7q2qyn-6"
})(["margin-left:0.35rem;cursor:pointer;"]);

var defaultShowMore = {
  disabled: true,
  numberShow: _utils.DEFAULT_FILTER_SHOW
};
var defaultSelectAll = {
  disabled: true,
  checkedAll: false
};

var CheckboxFilter = function CheckboxFilter(_ref) {
  var name = _ref.name,
      attribute = _ref.attribute,
      facets = _ref.facets,
      updateFilter = _ref.updateFilter,
      showMore = _ref.showMore,
      selectAll = _ref.selectAll,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showAll = _useState2[0],
      setShowAll = _useState2[1];

  if (!facets || facets && facets.length < 1) return null;

  var _defaultShowMore$show = _objectSpread(_objectSpread({}, defaultShowMore), showMore),
      hideShowMore = _defaultShowMore$show.disabled,
      numberShow = _defaultShowMore$show.numberShow;

  var _defaultSelectAll$sel = _objectSpread(_objectSpread({}, defaultSelectAll), selectAll),
      hideSelectAll = _defaultSelectAll$sel.disabled,
      checkedAll = _defaultSelectAll$sel.checkedAll;

  var displayFacets = facets.length > numberShow && !showAll ? facets.slice(0, numberShow) : facets;
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(Title, null, name), /*#__PURE__*/_react.default.createElement(FilterSearchForm, null), !hideSelectAll && /*#__PURE__*/_react.default.createElement(SelectAllElm, {
    type: "button",
    className: "toggleBtn",
    onClick: function onClick() {
      return updateFilter({
        checked: !checkedAll,
        attribute: attribute,
        facets: facets.map(function (_ref2) {
          var name = _ref2.name;
          return name;
        })
      });
    }
  }, checkedAll ? 'Deselect All' : 'Select All'), displayFacets.map(function (_ref3) {
    var checked = _ref3.checked,
        name = _ref3.name,
        count = _ref3.count;
    return /*#__PURE__*/_react.default.createElement(Facet, null, /*#__PURE__*/_react.default.createElement("input", {
      type: "radio",
      id: name,
      onClick: function onClick() {
        return updateFilter({
          checked: checked,
          attribute: attribute,
          facets: [name]
        });
      },
      readOnly: true,
      name: name,
      checked: checked
    }), /*#__PURE__*/_react.default.createElement(FacetLabel, {
      htmlFor: name
    }, count ? "".concat(name, " (").concat(count, ")") : name));
  }), !hideShowMore && facets.length > numberShow && /*#__PURE__*/_react.default.createElement(ToggleElm, {
    className: "toggleBtn",
    onClick: function onClick() {
      return setShowAll(!showAll);
    }
  }, showAll ? 'Show less...' : 'Show more...'));
};

CheckboxFilter.propTypes = {
  name: _propTypes.default.string.isRequired,
  attribute: _propTypes.default.string.isRequired,
  facets: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    checked: _propTypes.default.bool,
    count: _propTypes.default.number
  })),
  updateFilter: _propTypes.default.func.isRequired,
  showMore: _propTypes.default.shape({
    disabled: _propTypes.default.bool,
    numberShow: _propTypes.default.number
  }),
  selectAll: _propTypes.default.shape({
    disabled: _propTypes.default.bool,
    checkedAll: _propTypes.default.bool
  })
};
CheckboxFilter.defaultProps = {
  facets: [],
  showMore: {},
  selectAll: {}
};
var _default = CheckboxFilter;
exports.default = _default;